import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree
} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomStorageService} from "./global-services/custom-storage.service";
import {ProjectUtils} from "./utilities/project-utils";
import { MenuItemsService } from './layout/menu-items.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private customStorage: CustomStorageService,
    private menuItemsService: MenuItemsService) {
  }

  //menuItemsSub: Subscription;
  //ngOnDestroy() {
  //  if (this.menuItemsSub) { this.menuItemsSub.unsubscribe(); }
  //}

  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot): | boolean | UrlTree
    | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {

    const token = this.customStorage.getItem(ProjectUtils.userTokenLocStoreKey);

    if (token) {
      let fRouterURL = this.router.url;
      //console.log('fRouterURL: ' + fRouterURL + ' --routerURL: ' + router.url);
      if (fRouterURL.indexOf('/login')>-1) { return true; }

      let isVaildReq = this.menuItemsService.validateRouteURL(router.url);
      if (isVaildReq) {
        return true;
      }else{
        this.router.navigateByUrl('/404');
        return false;
      }
    }
    else {
      return this.router.createUrlTree(['/login']);
    }
  }
}
